import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import React from 'react';

import { Typography } from 'packages/common-frontend/components/Typography';

export const ConfirmDeleteModal = <
  T extends { name: string; label: string } | null
>({
  propertyToDelete,
  onClose,
  onDelete,
}: {
  propertyToDelete: T;
  onClose: () => void;
  onDelete: () => void;
}) => {
  return (
    <Modal isOpen={propertyToDelete !== null} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Modal Title</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Typography variant="base-muted">
            Are you sure you would like to delete {propertyToDelete?.label}?
          </Typography>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="outline"
            colorScheme="v2-aurora"
            mr={3}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button onClick={onDelete} colorScheme="v2-aurora">
            Confirm Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
